// extracted by mini-css-extract-plugin
export default {"section":"WrfoaE","accordion":"ULcEVN","title":"s5gte_","link":"LlKNpG","container":"ABVpj0"};